<template>
  <div class="login">
    <div id="login"></div>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import * as firebaseui from 'firebaseui'
// Firebase Auth
const CLIENT_ID = '290083127751-sqrmntj8ksa2f7g8mm2gvcuvbvv71trf.apps.googleusercontent.com'

export default {
  methods: {
    uiConfig() {
      let that = this
      return {
        callbacks: {
          // Called when the user has been successfully signed in.
          signInSuccessWithAuthResult: function (authResult) {
            if (authResult.user) {
              let email = authResult.user.email
              let e = email.split('@')[1]
              if (e === 'laika.studio' || e === 'legendlabs.com' || e === 'jhu.edu') {
                that.$router.push('/home')
              }
            }
            if (authResult.additionalUserInfo) {
              // document.getElementById('is-new-user').textContent = authResult
              //   .additionalUserInfo.isNewUser
              //   ? 'New User'
              //   : 'Existing User'
            }
            // Do not redirect.
            return false
          },
        },
        signInFlow: 'popup',
        signInOptions: [
          {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            // Required to enable this provider in One-Tap Sign-up.
            authMethod: 'https://accounts.google.com',
            // Required to enable ID token credentials for this provider.
            clientId: CLIENT_ID,
          },
          { provider: firebase.auth.EmailAuthProvider.PROVIDER_ID },
        ],
        tosUrl: 'https://www.google.com',
        privacyPolicyUrl: 'https://www.google.com',
        credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      }
    },
  },
  mounted() {
    // Init firebase auth
    let ui = firebaseui.auth.AuthUI.getInstance()

    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth())
    }
    // Disable auto-sign in.
    //ui.disableAutoSignIn()
    ui.start('#login', this.uiConfig())
  },
}
</script>
<style>
.login {
  background: #111216;
  color: #eee;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
p.firebaseui-tos.firebaseui-tospp-full-message {
  font-size: 9px;
  max-width: 60%;
  margin: 0 auto;
  padding-top: 20px;
  color: #fff;
}
.login.page {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
span.firebaseui-idp-text.firebaseui-idp-text-short {
  display: none;
}
ul.firebaseui-idp-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
span.firebaseui-idp-icon-wrapper {
  max-width: 40px;
}
button.firebaseui-idp-button.mdl-button.mdl-js-button.mdl-button--raised.firebaseui-idp-google.firebaseui-id-idp-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-around;
  height: 160px;
  width: 280px;
  margin: 0 auto;
  -ms-flex-direction: row;
  flex-direction: column;
  background-color: #222531 !important;
  border: 1px solid #111620;
  color: #fff;
  padding: 23px;
  cursor: pointer;
  -webkit-box-shadow: 0 0 21px 11px rgba(8, 10, 17, 0.21);
  box-shadow: none;
}

button.firebaseui-idp-button.mdl-button.mdl-js-button.mdl-button--raised.firebaseui-idp-password.firebaseui-id-idp-button {
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding: 10px 30px 8px;
  margin-top: 15px;
}
</style>
